import { fetchBaseQuery } from "@reduxjs/toolkit/dist/query";
import { Navigate } from "react-router-dom";
import { logoutSuccess, refreshToken } from "../store/reducers/authReducer";

const baseQuery = fetchBaseQuery({
    baseUrl: "https://booking-tutor.onrender.com/v1",
    credentials: 'include',
    prepareHeaders: (headers, { getState }) => {
        const token = getState().auth.accessToken;
        if (token) {
            headers.set('authorization', `Bearer ${token}`);
        }
        return headers;
    }
});
const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);
    if (result?.error?.status === 403) {
        const accessToken = await baseQuery('/auth/refresh', api, extraOptions);
        if (accessToken?.data) {
            await api.dispatch(refreshToken(accessToken.data));
            result = await baseQuery(args, api, extraOptions);
        } else {
            console.log('out');
            api.dispatch(logoutSuccess());
            Navigate('/login');
        }
    }
    return result;
};

export default baseQueryWithReauth;
